import React, { useState } from 'react';

interface CheckBoxProps {
  id: string;
  children: React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  value?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  id,
  children,
  name,
  value,
  onChange,
}) => {
  const [checked, setChecked] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    onChange?.(e);
  };

  return (
    <label className="checkbox-label">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        name={name}
        value={value}
        className="sr-only peer"
      />
      <span className="checkbox-span">
        <svg
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
        >
          <rect
            x="0"
            y="0"
            width="20"
            height="20"
            rx="4"
            fill="none"
            stroke="none"
          />
          <polyline
            points="5 11 9 15 15 7"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      </span>
      <span className="checkbox-label-text">{children}</span>
    </label>
  );
};

export default CheckBox;
